// extracted by css-extract-rspack-plugin
export default {"menu":"menu-U0hmze","menuList":"menuList-NEhiCC","menuItem":"menuItem-T2QBgb"};